import { render, staticRenderFns } from "./SubscriptionsTable.vue?vue&type=template&id=28347771"
import script from "./SubscriptionsTable.vue?vue&type=script&lang=js"
export * from "./SubscriptionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports